import { gql } from "@apollo/client";

const INSTAGRAM_LOGIN = gql`
  mutation instagramLogin(
    $code: String!
    $utm_source: String
    $utm_medium: String
    $utm_campaign: String
  ) {
    instagramLogin(
      code: $code
      utm_source: $utm_source
      utm_medium: $utm_medium
      utm_campaign: $utm_campaign
    ) {
      success
      error
      result
    }
  }
`;

export default INSTAGRAM_LOGIN;
